const ids = (
  state = {
    user: "",
    adjunct: 1,
    contractor: true,
    clockedin: true,
  },
  action
) => {
  switch (action.type) {
    case "ADD_IDS":
      return Object.assign({}, state, {
        ...action.idsBulk,
      });
    case "ADD_NEW_ID":
      return Object.assign({}, state, {
        [action.name]: action.value,
      });
    case "DROP_IDS":
      return {
        user: "",
        adjunct: 1,
      };
    default:
      return state;
  }
};

export default ids;
